import { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import AxiosInstance1 from "./AxiosInstance/AxiosInstance1";
const useGetViewOptions = (tagid) => {
  const [getViewOptions, setGetViewOptions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const roleID = userdata?.postId;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = sessionStorage.getItem("access_token");
        const url = `/api/PageAccess/Get?tagId=${tagid}&roleID=${roleID}`
        const response = await AxiosInstance1.get(url);

        if (response.status !== 200) {
          throw new Error("Failed to fetch dashboard data");
        }
        setGetViewOptions(response.data.data.lstPageAcess);
      } catch (error) {
        setError(error.message);
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { getViewOptions, loading, error };
};

export default useGetViewOptions;
